'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Object$keys = require('babel-runtime/core-js/object/keys')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _interopRequireWildcard = require('babel-runtime/helpers/interop-require-wildcard')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _componentsComponent = require('../../components/Component');

var _componentsComponent2 = _interopRequireDefault(_componentsComponent);

var _dbinfo = require('../../dbinfo');

var _dbinfo2 = _interopRequireDefault(_dbinfo);

var _constants = require('../../constants');

var Constants = _interopRequireWildcard(_constants);

var _componentsToolbar = require('../../components/Toolbar');

var _componentsToolbar2 = _interopRequireDefault(_componentsToolbar);

var _reactBootstrap = require('react-bootstrap');

var _reactisForms = require('reactis-forms');

var _reactisInputs = require('reactis-inputs');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactisModal = require('reactis-modal');

var _componentsFormDB = require('../../components/FormDB');

var _componentsFormDB2 = _interopRequireDefault(_componentsFormDB);

var _reactisLoader = require('reactis-loader');

var _componentsActionButton = require('../../components/ActionButton');

var _componentsActionButton2 = _interopRequireDefault(_componentsActionButton);

var _componentsSaveButton = require('../../components/SaveButton');

var _componentsSaveButton2 = _interopRequireDefault(_componentsSaveButton);

var _componentsFormClientLookup = require('../../components/Form/ClientLookup');

var _componentsFormClientLookup2 = _interopRequireDefault(_componentsFormClientLookup);

var _components = {
	_$Form: {
		displayName: 'Form'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var Form = (function (_FormDB) {
	_inherits(Form, _FormDB);

	function Form(props, context) {
		_classCallCheck(this, _Form);

		_FormDB.call(this, props, context);

		this.api = {
			fetch: 'project.fetch',
			save: 'project.save',
			remove: 'project.delete'
		};

		this.changeEvent = 'project.change';

		this.messages = {
			remove: 'Opravdu si přejete projekt odstranit?',
			notfound: 'Projekt nenalezen!'
		};

		this.schema = {
			title: {
				'class': _reactisInputs.TextInput,
				label: 'Název',
				autoFocus: !props.id,
				rules: {
					presence: { message: 'Název je povinná položka!' }
				}
			},
			client: {
				'class': _componentsFormClientLookup2['default'],
				label: 'Klient'
			},
			image: {
				'class': _reactisInputs.ImageUpload,
				label: 'Logo'
			},
			active: {
				'class': _reactisInputs.Checkbox,
				label: 'Aktivní'
			},
			notice: {
				'class': _reactisInputs.TextInput,
				label: 'Poznámka'
			}
		};
		this.form = new _reactisForms.FormManager(this.schema);
	}

	Form.prototype.componentDidMount = function componentDidMount() {
		var _this = this;

		this.form.on('change', function (key, value) {
			if (key == 'title') {
				_this.title = value;
			}
			_this.changed = true;
		});
		_FormDB.prototype.componentDidMount.call(this);
	};

	Form.prototype.updateTab = function updateTab(data) {
		this.props.updateTab({ title: data.title });
	};

	Form.prototype.render = function render() {
		var _this2 = this;

		var canEdit = true;

		var saveButton = _react2['default'].createElement(_componentsSaveButton2['default'], {
			disabled: !canEdit,
			loading: !!(this.props.form && this.props.form.get('saving')),
			onClick: function () {
				return _this2.save();
			}
		});

		var btns = _react2['default'].createElement(
			_reactBootstrap.ButtonToolbar,
			null,
			saveButton,
			this.props.id > 0 && _react2['default'].createElement(
				_componentsActionButton2['default'],
				{ disabled: !canEdit, bsStyle: 'danger', icon: 'fa fa-trash-o', onClick: function () {
						return _this2.remove();
					} },
				'Odstranit'
			)
		);

		return _react2['default'].createElement(
			'div',
			{ style: { position: 'relative' } },
			_react2['default'].createElement(_reactisLoader.Loader, { visible: !!(this.props.form && this.props.form.get('loading')) }),
			_react2['default'].createElement(
				_reactisForms.RxForm,
				{ ref: 'form', form: this.form, id: 'tab_' + this.props.tabid },
				_react2['default'].createElement(_componentsToolbar2['default'], { title: 'Projekt', buttons: btns }),
				_react2['default'].createElement(
					'div',
					{ className: 'row' },
					_react2['default'].createElement(
						'div',
						{ className: 'col-md-6' },
						_react2['default'].createElement(
							'table',
							{ className: 'form' },
							_react2['default'].createElement(
								'tbody',
								null,
								_Object$keys(this.schema).map(function (key) {
									return _react2['default'].createElement(_reactisForms.FormRow, { key: key, visible: _this2.schema[key].visible, name: key, labelWidth: '135' });
								}),
								_react2['default'].createElement(
									_reactisForms.FormRow,
									{ className: 'buttons' },
									saveButton
								)
							)
						)
					)
				)
			)
		);
	};

	var _Form = Form;
	Form = _wrapComponent('_$Form')(Form) || Form;
	Form = _reactRedux.connect(function (state, props) {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	}, function (dispatch) {
		return { actions: _redux.bindActionCreators(_reactisForms.actions, dispatch) };
	}, null, { withRef: true })(Form) || Form;
	return Form;
})(_componentsFormDB2['default']);

exports['default'] = Form;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Project/Form.js
 ** module id = 991
 ** module chunks = 2
 **/